module.exports = __webpack_public_path__ + "img/icon-type-4.3cfd4c33.png";